// extracted by mini-css-extract-plugin
module.exports = {"list":"style_list__j9tNZ","item":"style_item__YjEcr"};